import { render, staticRenderFns } from "./sale-days-sync-filters.vue?vue&type=template&id=237e6f75&scoped=true&"
import script from "./sale-days-sync-filters.vue?vue&type=script&lang=ts&"
export * from "./sale-days-sync-filters.vue?vue&type=script&lang=ts&"
import style0 from "./sale-days-sync-filters.vue?vue&type=style&index=0&id=237e6f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e6f75",
  null
  
)

export default component.exports